import { ClipboardCheck } from 'lucide-react'
import { Navigate } from 'react-router'
import { RequirePermission } from '@/features/auth/guards'
import { AttendanceRegisterPage } from '@/pages/attendance/AttendanceRegisterPage'
import { FamilyAttendancePage } from '@/pages/attendance/FamilyAttendancePage'
import { HolidaysPage } from '@/pages/attendance/HolidaysPage'
import { SectionHistoryPage } from '@/pages/attendance/SectionHistoryPage'
import { StaffAttendancePage } from '@/pages/attendance/StaffAttendancePage'
import type { AppModule } from '../moduleRegistry'

export const module: AppModule = {
  id: 'attendance',
  schoolModule: 'attendance',
  routes: {
    admin: [
      {
        path: 'attendance',
        element: <RequirePermission permission="attendance.view" />,
        children: [
          { index: true, element: <AttendanceRegisterPage /> },
          { path: 'holidays', element: <HolidaysPage /> },
          { path: 'sections/:id', element: <SectionHistoryPage /> },
          { path: 'sections', element: <Navigate to="/admin/attendance" replace /> },
        ],
      },
    ],
    staff: [
      {
        path: 'attendance',
        element: (
          <RequirePermission permission="attendance.mark">
            <StaffAttendancePage />
          </RequirePermission>
        ),
      },
    ],
    family: [{ path: 'attendance', element: <FamilyAttendancePage /> }],
  },
  nav: {
    admin: [
      {
        group: 'Operations',
        order: 10,
        item: {
          label: 'Attendance',
          to: '/admin/attendance',
          icon: ClipboardCheck,
          permission: 'attendance.view',
          children: [
            {
              label: 'Daily register',
              to: '/admin/attendance',
              permission: 'attendance.view',
              end: true,
              keywords: 'roll call present absent mark',
            },
            {
              label: 'Holidays',
              to: '/admin/attendance/holidays',
              permission: 'attendance.view',
              keywords: 'closures calendar public holiday',
            },
          ],
        },
      },
    ],
    staff: [
      {
        order: 15,
        item: {
          label: 'Attendance',
          to: '/staff/attendance',
          icon: ClipboardCheck,
          permission: 'attendance.mark',
          keywords: 'register roll call',
        },
      },
    ],
    family: [
      {
        order: 20,
        item: {
          label: 'Attendance',
          to: '/portal/attendance',
          icon: ClipboardCheck,
          keywords: 'absences present',
        },
      },
    ],
  },
}
